module.exports = __webpack_public_path__ + "img/ps-23.08c541c1.jpg";